export var MODULE_NAMESPACE = 'noodl.googleAnalyticsModule';
